import { render, staticRenderFns } from "./CultureMaterial.vue?vue&type=template&id=2cb21a24"
import script from "./CultureMaterial.vue?vue&type=script&lang=js"
export * from "./CultureMaterial.vue?vue&type=script&lang=js"
import style0 from "./CultureMaterial.vue?vue&type=style&index=0&id=2cb21a24&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports